import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: { padding: 30, fontFamily: 'Helvetica', fontSize: 10 },
  header: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 },
  logo: { maxWidth: 120, maxHeight: 60 },
  title: { fontSize: 20, fontWeight: 'bold' },
  table: { display: 'flex', width: 'auto', borderStyle: 'solid', borderColor: '#ccc', borderWidth: 1, borderRightWidth: 0, borderBottomWidth: 0 },
  tableRow: { margin: 'auto', flexDirection: 'row' },
  tableColHeader: { borderStyle: 'solid', borderColor: '#ccc', borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, padding: 5, backgroundColor: '#f0f0f0', fontWeight: 'bold' },
  tableCol: { borderStyle: 'solid', borderColor: '#ccc', borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, padding: 5 },
  tableCell: { margin: 2, fontSize: 8 } 
});

const ReportPdfDocument = ({ reportData, reportTitle, logoUrl }) => {
  if (!reportData || reportData.length === 0) return null;

  const headers = reportData[0] || [];
  const rows = reportData.slice(1);

  // Compute dynamic column widths based on longest string in each column
  const colMaxLengths = headers.map((header, colIndex) => {
    let maxLen = header.length;
    rows.forEach(row => {
      const cellText = row[colIndex] ? String(row[colIndex]) : '';
      if (cellText.length > maxLen) {
        maxLen = cellText.length;
      }
    });
    // Add padded minimums and cap extreme lengths (e.g. huge summaries)
    return Math.max(10, Math.min(maxLen, 80)); 
  });

  const totalLength = colMaxLengths.reduce((sum, len) => sum + len, 0);
  const colWidths = headers.length > 0 ? colMaxLengths.map(len => (len / totalLength) * 100 + '%') : [];

  return (
    <Document title={reportTitle ? `Search Report - ${reportTitle}` : 'Search Result Report'} author="Incident Xpress">
      <Page size="LETTER" orientation="landscape" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.title}>{reportTitle || 'Search Result Report'}</Text>
          {logoUrl ? <Image src={logoUrl} style={styles.logo} /> : <View />}
        </View>

        <View style={styles.table}>
          {/* Table Header */}
          <View style={styles.tableRow}>
            {headers.map((header, i) => (
              <View style={{ ...styles.tableColHeader, width: colWidths[i] }} key={`header-${i}`}>
                <Text style={styles.tableCell}>{header}</Text>
              </View>
            ))}
          </View>
          {/* Table Rows */}
          {rows.map((row, rowIndex) => (
            <View style={styles.tableRow} key={`row-${rowIndex}`}>
              {headers.map((_, cellIndex) => (
                <View style={{ ...styles.tableCol, width: colWidths[cellIndex] }} key={`cell-${rowIndex}-${cellIndex}`}>
                  {/* Handle multiline text from array like Corrective Actions using join */}
                  <Text style={styles.tableCell}>{row[cellIndex] || ''}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default ReportPdfDocument;
